import DataMapper from './DataMapper'
import DelayPercentageRM from '../responsemodel/DelayPercentageRM'
import DelayPercentage from '../../models/DelayPercentage'

class DelayPercentageDataMapper extends DataMapper<DelayPercentageRM, DelayPercentage> {
  map = (rm: DelayPercentageRM) => {
    return new DelayPercentage(
      rm.id,
      rm.initial_delay_percentage,
      rm.generation_delay_percentage,
      rm.allocation_delay_percentage,
      rm.finish_investigation_delay_percentage ?? 0,
      rm.initial_closure_delay_percentage,
      rm.final_closure_delay_percentage,
      rm.qc_delay_percentage,
      rm.missed_initiation_delay_percentage ?? 150
    )
  }
}

export default DelayPercentageDataMapper
